export default __webpack_public_path__ + "static/caption-03-cht-4c7ab018921af895f3d32bc2c46749a9.png";